import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { get } from "../../lib/request";
import { buildAlertAssigneesFetchKey, resolveSingleAlertClientId } from "./fetchCacheUtils";

export const fetchAlertPeople = createAsyncThunk(
  "alertPeople/fetch",
  async (arg, { rejectWithValue }) => {
    try {
      const clientId = resolveSingleAlertClientId(arg);
      if (clientId == null) {
        return rejectWithValue("clientId is required");
      }

      const res = await get(`alert-users?clientIds=${encodeURIComponent(clientId)}`);

      if (Array.isArray(res)) return res;
      if (Array.isArray(res?.data)) return res.data;
      if (Array.isArray(res?.data?.data)) return res.data.data;

      return [];
    } catch (err) {
      console.error("❌ fetchAlertPeople error:", err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg?.force === true) return true
      const key = buildAlertAssigneesFetchKey(arg)
      if (!key) return false
      const s = getState().alertPeople
      if (s.loading && s.lastFetchKey === key) return false
      if (s.status === "succeeded" && s.lastFetchKey === key) return false
      return true
    },
  },
);

const alertPeopleSlice = createSlice({
  name: "alertPeople",
  initialState: {
    people: [],
    loading: false,
    error: null,
    status: "idle",
    lastFetchKey: null,
  },
  reducers: {
    clearAlertPeople: (state) => {
      state.people = []
      state.loading = false
      state.error = null
      state.status = "idle"
      state.lastFetchKey = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertPeople.pending, (state, action) => {
        state.loading = true;
        state.status = "loading"
        state.lastFetchKey = buildAlertAssigneesFetchKey(action.meta.arg)
      })

      .addCase(fetchAlertPeople.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded"
        state.people = action.payload || [];
      })

      .addCase(fetchAlertPeople.rejected, (state, action) => {
        console.error("fetchAlertPeople rejected:", action.payload);
        state.loading = false;
        state.status = "failed"
        state.error = action.payload;
      });

  },
});

export const { clearAlertPeople } = alertPeopleSlice.actions
export default alertPeopleSlice.reducer;
